<template>
    <eden-confirm-dialog
      title="Reset Beautician Password"
      button-text="Reset"
      button-type="success"
      :show.sync="shouldShow"
      @confirm="reset"
    >
      <p>
        Are you sure you want to reset
        <strong class="text-grey-primary">{{ beauticianName }}'s </strong> password?
      </p>
    </eden-confirm-dialog>
  </template>
    
    <script>
  import beauticians from "@/requests/logistics/index.js";
  
  export default {
    name: "BeauticianPasswordReset",
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      beautician: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {};
    },
    computed: {
      shouldShow: {
        get() {
          return this.show;
        },
        set(value) {
          this.$emit("update:show", value);
        },
      },
      beauticianName() {
        return this.formatName(this.beautician.firstname + " " + this.beautician.lastname);
      },
    },
    methods: {
      closeEvent() {
        this.shouldShow = false;
      },
      reset() {
        const payload = {
          third_party_user_id: this.beautician.id,
          user_type: "beautician",
        };
        beauticians
          .reset(payload)
          .then((response) => {
            if (response.data.status) {
              this.$message.success(response.data.message);
              this.shouldShow = false;
            }
          })
          .catch((error) => {
            this.$message.error(error.response.data.message);
          });
      },
    },
  };
  </script>
    
    <style lang="scss"></style>
    